import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AllocateGroupFormResponse } from 'src/app/model/AllocateGroupFormResponse';
import { AllocateGroupLotteryListResponse } from 'src/app/model/AllocateGroupLotteryListResponse';
import { LotteryResponseModel } from 'src/app/model/LotteryResponseModel';
import { MasterService } from 'src/app/services/master.service';
interface KeyValuePair {
  key: string;
  value: string;
}

@Component({
  selector: 'app-allocate-group',
  templateUrl: './allocate-group.component.html',
  styleUrls: ['./allocate-group.component.scss'],
})



export class AllocateGroupComponent implements OnInit {

  AllocateGroupResponseModel: AllocateGroupFormResponse;
  allocateGroupLotteryListResponse: AllocateGroupLotteryListResponse;
  lotteryList: { [key: number]: string };
  form: FormGroup = new FormGroup({});

  options = ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5'];
  optionss = [];

  categories: { [key: number]: string };

  optionsGroup1 = [];
  optionsGroup2 = [];
  optionsGroup3 = [];
  selectedOptions = [];
  selectedOptions1 = [];
  selectedOptions2 = [];
  selectedOptions3 = [];
  lotterKey: number;

  newOption = '';
  groupOne: string[] = [];

  // optionsd = ['Option 1', 'Option 2', 'Option 3'];
  specialGroup1Options = [];
  specialGroup2Options = [];
  specialGroup3Options = [];
  selectedOptiond: string;
  isSubmitDisabled: boolean;



  constructor(

    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder
  ) { }
  ngOnInit(): void {
    console.log("allocate-group oninit Called");
    this.route.params.subscribe((params: Params) => {
      this.masterService
        .initAllocateGroupForm()
        .subscribe((data: any) => {
          if (data.status === 'SUCCESS') {
            console.log(data.lottery);
            this.lotteryList = data.lottery;
            

            console.log(this.lotteryList);
          }
        })
    });


    this.form = new FormGroup({
      lottery: new FormControl(null, Validators.required),
      Category: new FormControl(null, Validators.required),
      group1: new FormControl(null, Validators.required),
      group2: new FormControl(null, Validators.required),
      group3: new FormControl(null, Validators.required),
      specialGroupOne: new FormControl(),
      specialGroupTwo: new FormControl(),
      specialGroupThree: new FormControl(),
    });

  }

  onDropdownChange(e: any) {
    console.log('*********Selected value: ', e.value);
    console.log(e.value?.key);

    this.lotterKey = e.value?.key;
    console.log(this.lotterKey);
    if (this.lotterKey) {
      this.masterService
        .getLotteryCategoryListBykey(this.lotterKey).subscribe((data: any) => {
          console.log('Data from DB',data);
          // console.log('value*****',data.categoryGroup.key,data.categoryGroup.key);
          
          if(data.categoryGroup1 != null){
            this.optionsGroup1 = data.categoryGroup1;
          }
          if(data.categoryGroup2 != null){
            this.optionsGroup2 = data.categoryGroup2;
          }
          if(data.categoryGroup3 != null){
            this.optionsGroup3 = data.categoryGroup3;
          }

          this.form.patchValue({
            specialGroupOne: {
              key: Object.keys(data.isSpecialCategory1)[0],
              value: data.isSpecialCategory1[Object.keys(data.isSpecialCategory1)[0]]
            },
            specialGroupTwo:{
              key: Object.keys(data.isSpecialCategory2)[0],
              value: data.isSpecialCategory2[Object.keys(data.isSpecialCategory2)[0]]
            },
            specialGroupThree:{
              key: Object.keys(data.isSpecialCategory3)[0],
              value: data.isSpecialCategory3[Object.keys(data.isSpecialCategory3)[0]]
            }
          });
          
          this.categories = data.category;
          


        }, error => {
          this.isSubmitDisabled = false;
          console.log(error);
          // this.errorToast(error.error.errorMessage, 5 * 1000);
        });
    }


  }

  addToGroup1() {

    console.log(this.selectedOptions);
    this.selectedOptions.map(s => {
      if(s['value']) {
        this.optionsGroup1[s['key']+''] = s['value'];
        delete this.categories[s['key']];
      }  
    });
    //this.optionsGroup1.forEach(val => this.specialGroup1Options.push(Object.assign({}, val)));

    // this.specialGroup1Options = this.optionsGroup1;
    console.log("for special group" + this.specialGroup1Options);

    this.selectedOptions = [];
    console.log('after clear selected',this.selectedOptions);
    this.addCategoryToast("Category Added to Group-1");
  }

  removeFromGroup1() {
    console.log(this.selectedOptions1);
    this.selectedOptions1.map(s => {
      console.log(s);
      this.categories[s['key']+''] = s['value'];
      delete this.optionsGroup1[s['key']];
    });
    this.selectedOptions1 = [];
    this.removeCategoryToast("Category Removed from Group-1");
  }



  addToGroup2() {
    console.log(this.selectedOptions);
    this.selectedOptions.map(s => {
      if(s['value']) {
        this.optionsGroup2[s['key']+''] = s['value'];
        delete this.categories[s['key']];
      }
    });

    this.selectedOptions = [];
    this.addCategoryToast("Category Added to Group-2")
  }

  removeFromGroup2() {
    console.log(this.selectedOptions2);
    this.selectedOptions2.map(s => {
      console.log(s);
      this.categories[s['key']+''] = s['value'];
      delete this.optionsGroup2[s['key']];
    });
    this.selectedOptions2 = [];
    this.removeCategoryToast("Category Removed from Group-2");
  }


  addToGroup3() {


    console.log(this.selectedOptions);
    this.selectedOptions.map(s => {
      this.optionsGroup3[s['key']+''] = s['value'];
      delete this.categories[s['key']];
    });

    this.specialGroup3Options = this.optionsGroup3;
    this.selectedOptions = [];
    this.addCategoryToast("Category Added to Group-3")
  }

  removeFromGroup3() {
    console.log(this.selectedOptions3);
    this.selectedOptions3.map(s => {
      console.log(s);
      this.categories[s['key']+''] = s['value'];
      delete this.optionsGroup3[s['key']];
    });
    this.selectedOptions3 = [];
    this.removeCategoryToast("Category Removed from Group-3");
  }





  onSubmit() {
    console.log('special category group key = ',this.form.value.specialGroupTwo?.key,
    this.form.value.specialGroupTwo?.value);

    this.masterService.saveAllocateGroup({
      lotteryKey: this.form.value.lottery?.key,
      group1CategoryKeys: Object.keys(this.optionsGroup1),
      group2CategoryKeys: Object.keys(this.optionsGroup2),
      group3CategoryKeys: Object.keys(this.optionsGroup3),
      specialGroup1Category: this.form.value.specialGroupOne?.key,
      specialGroup2Category: this.form.value.specialGroupTwo?.key,
      specialGroup3Category: this.form.value.specialGroupThree?.key
    }).subscribe((data: any) => {
        if (data.status === 'SUCCESS') {
          this.successToast();
          // this.ngOnInit();
          //this.router.navigate(["/secure", "home"]);
        }
        else {
          // this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        // this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5 * 1000);
      });

  }

  addOption() {
    if (this.newOption !== '' && !this.options.includes(this.newOption)) {
      this.options.push(this.newOption);
      this.newOption = '';
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Lottery Group saved successfully.",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }
  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    }
    );
  }

  async addCategoryToast(message: string) {
    await this._snackBar.open(
      message,
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async removeCategoryToast(message: string) {
    await this._snackBar.open(
      message,"Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  showLottery(o1: any, o2: any) {
    if (o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }





}



